<template>
  <div id="home" class="view-home">
    <mini-banner
      v-if="show_banner_parcelamento"
      :description="'Parcele seus pedidos em até 3 vezes no cartão de crédito'"
      :type-alert="'home'"
    ></mini-banner>

    <section v-for="(componente, index) in sortedComponents" :key="componente.componente_id || index" :data-componente-id="componente.componente_id" :data-componente-nome="componente.descricao" :data-componente-secao="componente.secao_id" :data-componente-ordem="componente.ordem">
      <ComponentRenderer
        :componente="componente"
        :is-loading="isLoading"
        :is-loading-products="isLoadingProducts"
      />
    </section>

    <!-- Pop-Ups (secao_id=4) — overlays renderizados fora do flow do body. -->
    <ComponentRenderer
      v-for="popup in popupComponents"
      :key="'popup-' + popup.componente_id"
      :componente="popup"
      :is-loading="false"
      :is-loading-products="false"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Newsletter from "@/components/newsletter/Newsletter";
import BannersDestaque from "@/components/banners-destaque/BannersDestaque";
import MiniBanner from "@/components/banner/MiniBanner.vue";
import ComponentRenderer from "@/components/componentes/ComponentRenderer";
import componentesProcessamento from "@/mixins/componentesProcessamento";

export default {
  name: "Home",
  components: {
    BannersDestaque,
    Newsletter,
    MiniBanner,
    ComponentRenderer,
  },
  mixins: [componentesProcessamento],
  data() {
    return {
      show_banner_parcelamento: false,
    };
  },

  computed: {
    ...mapGetters({
      storeComponents: "homeComponents",
      storeIsLoadingComponents: "isLoadingComponents",
    }),
    pedidoAtual() {
      return this.$store.getters.dadosPedido;
    },
    popupComponents() {
      return (this.componentes || []).filter((c) => Number(c.secao_id) === 4);
    },
    sortedComponents() {
      const components = this.componentes || [];
      return components
        .filter((c) => Number(c.secao_id) === 2)
        .sort((a, b) => {
          const firstSection = Number(a && a.secao_id ? a.secao_id : 0);
          const secondSection = Number(b && b.secao_id ? b.secao_id : 0);
          const sectionDiff = firstSection - secondSection;
          if (sectionDiff !== 0) {
            return sectionDiff;
          }
          const firstOrder = Number(a && a.ordem ? a.ordem : 0);
          const secondOrder = Number(b && b.ordem ? b.ordem : 0);
          return firstOrder - secondOrder;
        });
    },
  },

  watch: {
    async pedidoAtual(newValue, oldValue) {
      if (!oldValue) return;

      const mesmoPedido =
        newValue.condicaoPagamento == oldValue.condicaoPagamento &&
        newValue.pedidoId == oldValue.pedidoId &&
        newValue.razao == oldValue.razao &&
        newValue.tabvnd == oldValue.tabvnd &&
        newValue.formaPagamento == oldValue.formaPagamento &&
        newValue.unidade == oldValue.unidade;
      if (mesmoPedido) return;

      if (newValue.unidade != oldValue.unidade) {
        this.$store.dispatch("fetchAllComponents");
        return;
      }

      const ids = (this.componentes || [])
        .filter((c) => c.tipo_id == 6)
        .map((c) => c.componente_id);
      if (ids.length > 0) {
        this.getComponentProdutos(ids);
      }
    },
    storeComponents(newComponents) {
      if (newComponents && newComponents.length > 0) {
        this.processComponents(newComponents);
      }
    },
  },

  created() {
    this.show_banner_parcelamento =
      process.env.VUE_APP_SHOW_BANNER_PARCELAMENTO != "false";

    if (this.storeComponents && this.storeComponents.length > 0) {
      this.processComponents(this.storeComponents);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/sass/bootstrap/variables";

.slider-full-loading {
  min-height: 290px;
  background-color: $gray-lighter;
}

.parceiros-slider-loading {
  min-height: 100px;
  background: darken($gray-lighter, 3%) !important;
}

.banner-1-loading {
  min-height: 290px;
  background-color: $gray-lighter;
}

.session-header {
  color: $gray;
  margin-bottom: 20px;
  font-weight: 600;
  font-family: "Montserrat";
}

#slider-produtos {
  padding-top: 20px;
  padding-bottom: 40px;
  background-color: $gray-pale;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  color: white;
}
</style>
